'use client'
import { forwardRef, Step as ChakraStep } from '@chakra-ui/react'
import { LegacyRef } from 'react'

import { StepProps } from './Step.types'

export default forwardRef(function Step(
  props: StepProps,
  ref: LegacyRef<HTMLDivElement>
) {
  return <ChakraStep {...props} ref={ref} translate="no" />
})
